<script setup lang="ts">
const props = defineProps<{
  right?: boolean
  inline?: boolean
  country: gen.BuyerAddressCountryFragment | None | { iso2: string | None }
  iso2?: string | None
  flagOnly?: boolean
}>()

const iso = computed(() => props.country?.iso2 || props.iso2 || undefined)
const { country: countryFull } = useCountriesMultiget(() => ({ iso2: iso.value }))
const title = computed(() => countryFull.value?.title?.value)
</script>

<template>
  <div v-if="iso" :class="[{ _inline: inline }]" class="_lh1 _fs09 _row _gap06 _ctrY _h24">
    <UiCountryImg v-if="!right" :country="countryFull" :iso2="iso" />
    <span v-if="!flagOnly" :class="[$style.label, title ? '_opacity1' : '_opacity0']">
      <span>{{ title }}</span>
    </span>
    <UiCountryImg v-if="right" :country="countryFull" :iso2="iso" />
  </div>
</template>

<style module>
.label {
  composes: global(_row);
  composes: global(_ctrY);
  composes: global(_gap04);
  composes: global(_fw-l);
  composes: global(_ls-xs);
  transition: opacity 60ms var(--tran2);
}
</style>
